import React from 'react';
import Button from 'react-bootstrap/Button';
import classNames from 'classnames';
import './styles.scss';

interface Props {
  children: string;
  disabled?: boolean;
  primary?: boolean;
  onClick?: any;
}

const ModalButton: React.FC<Props> = ({ children, disabled = false, primary = true, onClick }) => {
  const mainClass = classNames({
    'btn-modal': true,
    'btn-modal-primary': primary,
    'btn-modal-secondary': !primary
  });
  return (
    <Button className={mainClass} disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  );
};

export default ModalButton;
